"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var VerifiableCredential_1 = require("./VerifiableCredential");
var BaseValidationObject_1 = require("./BaseValidationObject");
var DID_1 = require("../DID/DID");
var DIDDocument_1 = require("../DID/DIDDocument");
var Presentation = /** @class */ (function (_super) {
    __extends(Presentation, _super);
    function Presentation(verifiableCredentials, presentationSchema, context) {
        if (context === void 0) { context = "iota.org"; }
        var _this = _super.call(this, context, presentationSchema) || this;
        _this.verifiableCredentials = verifiableCredentials;
        return _this;
    }
    Presentation.Create = function (verifiableCredentials, presentationSchema, context) {
        if (context === void 0) { context = "iota.org"; }
        return new Presentation(verifiableCredentials, presentationSchema, context);
    };
    Presentation.DecodeFromJSON = function (presentationData, provider, presentationSchema) {
        var _this = this;
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var verifiableCredentials, context, i, issuerDID, issuerRoot, issuerDIDDoc, issuerKeyId, nonce, vc;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        verifiableCredentials = [];
                        context = presentationData["@context"][1];
                        i = 0;
                        _a.label = 1;
                    case 1:
                        if (!(i < presentationData.verifiableCredential.length)) return [3 /*break*/, 4];
                        issuerDID = new DID_1.DID(presentationData.verifiableCredential[i].proof.verificationMethod);
                        issuerRoot = issuerDID.GetUUID();
                        return [4 /*yield*/, DIDDocument_1.DIDDocument.readDIDDocument(provider, issuerRoot)];
                    case 2:
                        issuerDIDDoc = _a.sent();
                        issuerKeyId = issuerDID.GetFragment();
                        nonce = presentationData.verifiableCredential[i].proof.nonce;
                        vc = VerifiableCredential_1.VerifiableCredential.DecodeFromJSON(presentationData.verifiableCredential[i], { 'issuer': issuerDIDDoc, 'issuerKeyId': issuerKeyId, 'challengeNonce': nonce });
                        if (vc) {
                            verifiableCredentials.push(vc);
                        }
                        else {
                            reject("Invalid Verifiable Credential");
                        }
                        _a.label = 3;
                    case 3:
                        i++;
                        return [3 /*break*/, 1];
                    case 4:
                        resolve(new Presentation(verifiableCredentials, presentationSchema, context));
                        return [2 /*return*/];
                }
            });
        }); });
    };
    Presentation.prototype.EncodeToJSON = function () {
        var verifiableCredentialObjects = [];
        for (var i = 0; i < this.verifiableCredentials.length; i++) {
            verifiableCredentialObjects.push(this.verifiableCredentials[i].EncodeToJSON());
        }
        var types = ["VerifiablePresentation"];
        if (this.schema) {
            types.push(this.schema.GetName());
        }
        var credentialData = {
            "@context": this.contexts,
            type: types,
            verifiableCredential: verifiableCredentialObjects
        };
        return credentialData;
    };
    Presentation.prototype.GetVerifiableCredentials = function () {
        return this.verifiableCredentials;
    };
    return Presentation;
}(BaseValidationObject_1.BaseValidationObject));
exports.Presentation = Presentation;
//# sourceMappingURL=Presentation.js.map